/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { ConversationShowPathParams, ConversationShowResponse } from '../types/ConversationShow'

/**
 * GET /ai/conversations/:conversationId
 * @see backend/nexus/modules/AIAssistant/Http/Controllers/ConversationController.php ConversationController::show
 */
export async function conversationShow(
	conversationId: ConversationShowPathParams['conversationId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<ConversationShowResponse>> {
	return axiosInstance.get(`/ai/conversations/${conversationId}`, config)
}
